<template>
	<div
		:id="id"
		class="menu-item item"
		:class="{ selectable: !disabled }"
		@mouseenter="handleMouseEnter"
	>
		<slot name="arrow" />
		<a
			class="body"
			:class="{ 'body-left': !!label, 'body-center': !label }"
			:href="link"
			@click.prevent.stop="emitAction"
		>
			<span class="menu-item--label">
				<Icon
					v-if="icon && !hideIcon"
					:icon-name="icon"
					:size="iconSize"
					class="menu-item--label--icon"
				/>
				<span
					v-if="label"
					class="label"
				>
					{{ label }}
				</span>
				<Icon
					v-if="selected"
					icon-name="check"
					size="sm"
					class="menu-item--check"
				/>
			</span>
		</a>
	</div>
</template>

<script>
import Icon from '@components/Icon';

export default {
	name:       'ContextMenuItem',
	components: { Icon },
	props:      {
		id: {
			type:    String,
			default: '',
		},
		action: {
			type:    String,
			default: '',
		},
		value: {
			type:    [Number, String, Object],
			default: null,
		},
		disabled: {
			type: Boolean,
		},
		link: {
			type:    String,
			default: '',
		},
		label: {
			type:    String,
			default: '',
		},
		icon: {
			type:    String,
			default: '',
		},
		iconSize: {
			type:    String,
			default: 'sm',
		},
		selected: {
			type: Boolean,
		},
		hideIcon: {
			type: Boolean,
		},
	},
	data() {
	  return {
			locked: true,
		};
	},
	methods: {
	  	handleMouseEnter() {
	    	this.$emit('locked');
		},
		emitAction() {
			this.$emit(this.action, this.value);
			this.$emit('click', this.id, this.action, this.value);
			this.$emit('close-context-menu');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

$menu-item-border-radius: 4px;

.menu-item {
	background-color: var(--color-grey-850);

	body.-t-light & {
		background-color: var(--color-white);
	}

	&:hover {
		background-color: var(--color-grey-750);

		body.-t-light & {
			background-color: var(--color-grey-950);
		}
	}

	.menu-item--label {
		@extend .text-sm;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;

		span {
			margin-left: 17px;
		}

		.menu-item--label--icon {
			margin-left: 17px;
		}

		.menu-item--check {
			color: var(--color-hype-yellow);
			margin-left: 30px;
		}

		.label {
			flex-grow: 1;
		}
	}

	.body {
		color: var(--color-soft-white);
		border-bottom: none;
		padding: 14px 19px 14px 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: flex;
		flex-direction: row;
		align-items: center;

		&.body-center {
			justify-content: center;
		}

		&.body-left {
			justify-content: left;
		}

		body.-t-light & {
			color: var(--color-black);
		}
	}

	&.danger .body {
		color: var(--color-red);
	}

	&:first-child {
		border-top-left-radius: $menu-item-border-radius;
		border-top-right-radius: $menu-item-border-radius;
	}

	&:last-child {
		border-bottom: none;
		border-bottom-left-radius: $menu-item-border-radius;
		border-bottom-right-radius: $menu-item-border-radius;
	}
}

</style>
